// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChipFilter_container__v\\+Zwr {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  padding: calc(var(--gutter) / var(--golden-ratio)) var(--gutter);
  background: var(--color-surface-light);
}

.ChipFilter_label__1SCw4 {
  font-weight: 500;
}

.ChipFilter_chip__CtzNt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  min-width: 40px;
  border-radius: var(--radius-full);
  background: var(--color-surface);
  color: var(--color-text-subtle);
  border: 1px solid var(--color-border);
  transition: background 0.15s, color 0.15s, border 0.15s;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.ChipFilter_chip__CtzNt:hover {
  background: var(--color-surface-darker);
  color: var(--color-text);
  border: 1px solid var(--color-border);
}
.ChipFilter_chip__CtzNt.ChipFilter_selected__HQfGF {
  background: var(--color-primary);
  color: var(--color-text-light);
  border: 1px solid transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/ChipFilter/ChipFilter.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,gEAAA;EACA,sCAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;EACA,gCAAA;EACA,+BAAA;EACA,qCAAA;EACA,uDAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AACF;AACE;EACE,uCAAA;EACA,wBAAA;EACA,qCAAA;AACJ;AAEE;EACE,gCAAA;EACA,8BAAA;EACA,6BAAA;AAAJ","sourcesContent":[".container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.25rem;\n  padding: calc(var(--gutter) / var(--golden-ratio)) var(--gutter);\n  background: var(--color-surface-light);\n}\n\n.label {\n  font-weight: 500;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  min-width: 40px;\n  border-radius: var(--radius-full);\n  background: var(--color-surface);\n  color: var(--color-text-subtle);\n  border: 1px solid var(--color-border);\n  transition: background 0.15s, color 0.15s, border 0.15s;\n  cursor: pointer;\n  user-select: none;\n  \n  &:hover {\n    background: var(--color-surface-darker);\n    color: var(--color-text);\n    border: 1px solid var(--color-border);\n  }\n  \n  &.selected {\n    background: var(--color-primary);\n    color: var(--color-text-light);\n    border: 1px solid transparent;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChipFilter_container__v+Zwr`,
	"label": `ChipFilter_label__1SCw4`,
	"chip": `ChipFilter_chip__CtzNt`,
	"selected": `ChipFilter_selected__HQfGF`
};
export default ___CSS_LOADER_EXPORT___;
